import { useRouteLoaderData } from "react-router-dom"
import AdminPlatformPoliciesShow from "../../components/admin/AdminPlatformPoliciesShow.jsx"
import { GetPlatformPolicy } from "../../repo/PlatformPoliciesRepo.js"
import { GetTournament } from "../../repo/TournamentsRepo.js"

export default function PlatformPolicyShowPage() {
  const { platformPolicy, tournament } = useRouteLoaderData('admin-platform-policy-show')

  return(
    <section className="m-8">
      {platformPolicy && tournament && (
        <AdminPlatformPoliciesShow tournament={tournament} platformPolicy={platformPolicy}/>
      )}
    </section>
  )
}

export async function loader({ params, request }) {  
  return {
    platformPolicy: await GetPlatformPolicy(params.tournamentId, params.id),
    tournament: await GetTournament(params.tournamentId)
  }
}
